import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {LoadingButton} from '@mui/lab';
import {Box, Button, Divider, IconButton, Tooltip} from '@mui/material';
import {useState} from 'react';

import {ExportField} from '../../interfaces/Export';
import ExportPdfButton from './ExportPdfButton';
import ModalFixed from './ModalFixed';

interface ReportExportButtonProps {
  title: string;
  endpoint: string;
  defaultFilename: string;
  params?: Record<string, unknown>;
  additionalParams?: Record<string, unknown>;
  exportFields?: ExportField[];
  onExportCsv?: () => void;
  csvExportInProgress?: boolean;
}

const ReportExportButton = ({
  title,
  endpoint,
  defaultFilename,
  params,
  additionalParams,
  exportFields,
  onExportCsv,
  csvExportInProgress,
}: ReportExportButtonProps) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <Button
          size="small"
          variant="outlined"
          onClick={() => setIsOpened(true)}
        >
          <FileDownloadIcon />
        </Button>
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <FileDownloadIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>{title}</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              {onExportCsv ? (
                <LoadingButton
                  fullWidth
                  size="large"
                  variant="contained"
                  loading={csvExportInProgress}
                  onClick={() => {
                    onExportCsv();
                    setIsOpened(false);
                  }}
                >
                  Export to Excel
                </LoadingButton>
              ) : null}
              <ExportPdfButton
                endpoint={endpoint}
                defaultFilename={defaultFilename}
                params={params}
                additionalParams={additionalParams}
                exportFields={exportFields}
              />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default ReportExportButton;
